module.exports = __webpack_public_path__ + "img/discussion-upvote.b32841c0.svg";